export class TabManager {
  private tabButtons = {
    reports: document.getElementById("tabbtn-reports") as HTMLButtonElement,
    upload: document.getElementById("tabbtn-upload") as HTMLButtonElement,
    mapping: document.getElementById("tabbtn-mapping") as HTMLButtonElement,
  };
  private tabPanels = {
    reports: document.getElementById("tab-reports") as HTMLElement,
    upload: document.getElementById("tab-upload") as HTMLElement,
    mapping: document.getElementById("tab-mapping") as HTMLElement,
  };

  private tabKeys: (keyof typeof this.tabButtons)[] = [];

  constructor() {
    this.tabKeys = Object.keys(this.tabButtons) as (keyof typeof this.tabButtons)[];
    this.wireEvents();
    this.activateTab("reports");
  }

  private activateTab = (tab: keyof typeof this.tabButtons) => {
    (Object.entries(this.tabButtons) as [typeof tab, HTMLButtonElement][]).forEach(([key, btn]) => {
      const on = key === tab;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
      if (on) btn.focus();
    });
    (Object.entries(this.tabPanels) as [typeof tab, HTMLElement][]).forEach(([key, panel]) => {
      const on = key === tab;
      panel.hidden = !on;
      panel.classList.toggle("is-active", on);
    });
  };

  private getNextTab(currentTab: keyof typeof this.tabButtons, direction: 'next' | 'prev'): keyof typeof this.tabButtons {
    const currentIndex = this.tabKeys.indexOf(currentTab);
    let nextIndex;
    
    if (direction === 'next') {
      nextIndex = (currentIndex + 1) % this.tabKeys.length;
    } else {
      nextIndex = currentIndex === 0 ? this.tabKeys.length - 1 : currentIndex - 1;
    }
    
    return this.tabKeys[nextIndex];
  }

  private wireEvents() {
    this.tabKeys.forEach(key => {
      this.tabButtons[key]?.addEventListener("click", () => this.activateTab(key));
    });

    this.tabKeys.forEach(key => {
      const btn = this.tabButtons[key];
      btn?.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          const direction = e.key === "ArrowRight" ? "next" : "prev";
          const nextTab = this.getNextTab(key, direction);
          this.activateTab(nextTab);
        }
      });
    });
  }
}
